import Box from '@components/base/Box'
import Tooltip from '@components/tootilp/Tooltip'
import React from 'react'
import { BaseInputProps } from './BaseInputProps'
import { validate } from './Validations'

export interface CheckboxInputProps extends BaseInputProps {
  children: JSX.Element
  border?: string
  customStyles?: string
}

/**
 * Primary UI component for checkbox inputs.
 */
export const CheckboxInput = ({
  label,
  show = true,
  value = '',
  onChange,
  className,
  validations,
  required,
  testid,
  children,
  border = 'border',
  customStyles,
}: CheckboxInputProps) => {
  const errorMessage = validate(value, validations)
  const checked = value === true

  if (!show) return <></>
  return (
    <fieldset
      className={`flex flex-col gap-3 bg-transparent text-sm transition-all ${
        errorMessage ? 'text-red-500' : ''
      } ${className}`}
    >
      {label && border?.length > 0 && (
        <legend
          className={`text-sm font-medium text-[#153e3e] transition-all ${
            errorMessage ? 'text-red-500' : ''
          }`}
        >
          <Tooltip show={required} tooltip="Required to publish.">
            <span
              className={
                required
                  ? "after:content-['*'] after:ml-1 after:text-red-500"
                  : ''
              }
            >
              {label}
            </span>
          </Tooltip>
        </legend>
      )}
      <label
        className={`flex w-full cursor-pointer items-start gap-2 text-sm font-medium text-[#153e3e] ${
          customStyles ?? ''
        }`}
      >
        <input
          data-testid={testid ? `${testid}` : null}
          type="checkbox"
          className="peer sr-only"
          name={label}
          checked={checked}
          onClick={(e) => {
            e.stopPropagation()
          }}
          onChange={(e) => {
            onChange && onChange(e.target.checked, false)
          }}
        />
        <span
          aria-hidden="true"
          className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center border-2 border-[#153e3e] bg-transparent transition-all after:hidden after:h-2 after:w-1 after:rotate-45 after:border-b-2 after:border-r-2 after:border-white peer-checked:bg-[#153e3e] peer-checked:after:block peer-focus-visible:ring-2 peer-focus-visible:ring-[#153e3e]/30"
        />
        <Box className="min-w-0 text-[#153e3e]">{children}</Box>
      </label>

      <Box
        ignoreTheme
        className={`transition-all ${
          errorMessage ? 'opacity-100' : 'opacity-0'
        } text-red-500 text-sm font-bold`}
      >
        {errorMessage ?? '-'}
      </Box>
    </fieldset>
  )
}
